import React, { memo } from 'react';

const MessageIcon = (props) => (
    <svg
        width="27"
        height="18"
        viewBox="0 0 27 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M26.8788 9.18599L22.8969 0.829794C22.6409 0.314788 22.1289 0 21.5884 0H5.43268C4.86387 0 4.35179 0.314798 4.12419 0.829794L0.142257 9.18599C0.0569424 9.3864 0 9.61516 0 9.81556V16.5406C0 17.3419 0.654141 18 1.45055 18H25.5419C26.3383 18 26.9924 17.3419 26.9924 16.5406L26.9926 9.81556C27.021 9.61534 26.9641 9.38639 26.8788 9.18599H26.8788ZM17.2366 8.21306C16.6961 8.21306 16.1842 8.5564 16.0136 9.07162C15.6724 10.1304 14.6768 10.9031 13.4822 10.9031C12.2876 10.9031 11.3206 10.1304 10.9508 9.07162C10.7801 8.55661 10.2681 8.21306 9.7278 8.21306H3.81163L6.31467 2.94751H20.6216L23.1246 8.21306C23.1528 8.18451 19.1992 8.18451 17.2364 8.21306H17.2366Z"
            fill="currentColor"
        />
    </svg>
);

export default memo(MessageIcon);
